import React from 'react';
import PhoneInput from 'react-phone-input-2';
import classNames from 'classnames';
import { ErrorMessage, useField } from 'formik';

import 'react-phone-input-2/lib/bootstrap.css';
import styles from './FormikPhoneInput.module.scss';

export const FormikPhoneInput = ({
  name,
  label,
  shouldDisplayLabel = true,
  isRequired,
  isOptional,
  CustomIcon,
  onIconClick,
  isSignupFlow = false,
  ...props
}) => {
  const [field, meta, { setValue }] = useField(name);

  return (
    <div id={styles.PhoneField} className={styles.container}>
      {shouldDisplayLabel && (
        <label htmlFor={name} className={styles.label}>
          {label} {isRequired && !isSignupFlow && <span className={styles.required}>*</span>}{' '}
          {isOptional && <span className={styles.optional}>(Optional)</span>}
        </label>
      )}
      <div className={styles.phoneInputContainer}>
        <PhoneInput
          {...field}
          {...props}
          inputClass={classNames(styles.phoneInput, {
            [styles.error]: meta.touched && meta.error,
          })}
          specialLabel=""
          placeholder=""
          value={field.value}
          country="us"
          onChange={(phone) => setValue(phone)}
          enableSearch
          inputProps={{
            'data-testid': props['data-testid'],
          }}
        />
        {CustomIcon && (
          <button
            style={{ cursor: `${onIconClick ? 'pointer' : 'auto'}` }}
            type="button"
            className={styles.iconButton}
            onClick={onIconClick}
          >
            <CustomIcon />
          </button>
        )}
      </div>
      <ErrorMessage name={name} component="div" className={styles.errorMessage} />
    </div>
  );
};
